import React, { useCallback, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function LimitTextArea(_ref) {
  var rows = _ref.rows,
      cols = _ref.cols,
      value = _ref.value,
      limit = _ref.limit,
      placeholder = _ref.placeholder;

  var _useState = useState(value.slice(0, limit)),
      content = _useState[0],
      setContent = _useState[1];

  var setFormattedContent = useCallback(function (text) {
    setContent(text.slice(0, limit));
  }, [limit, setContent]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("textarea", {
      rows: rows || 5,
      cols: cols || 50,
      className: "h-36 w-full rounded-md border-2 border-gray-100 focus:border-black focus:ring-0",
      placeholder: placeholder || '',
      onChange: function onChange(event) {
        return setFormattedContent(event.target.value);
      },
      value: content
    }), /*#__PURE__*/_jsxs("p", {
      className: "text-xs text-gray-400",
      children: [content.length, "/", limit]
    })]
  });
}
export default LimitTextArea;